var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-footer"},[_vm._m(0),_c('div',{domProps:{"innerHTML":_vm._s(`&copy; My Space 1A - ${_vm.currentYear()}`)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Centro de descargas")])])
}]

export { render, staticRenderFns }